
import React, { useState, forwardRef, useRef } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import { BootstrapDialog, BootstrapDialogTitle } from '../reusableComponent/BootstrapDialog'
import { StyledTableCell, StyledTableRow } from '../reusableComponent/StyledTable';
import styles from '../../styles.module.css';



const PaymentInvoiceDetails = (props) => {
    const login_details = sessionStorage.getItem('loginUser');
    const userInfo = JSON.parse(login_details);
    const location = useLocation();

    const detailsView = props.details;
    const [open, setOpen] = useState(false)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = (info) => {
        // setInfo(info);
        setOpen(true);
    };
    return (
        <>

            <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>

                <Box>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item md={12}>
                            <Grid container spacing={2} sx={{ mt: 0 }}>
                                <Grid item md={3.4}>

                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>{location.pathname == '/sales' ? "Customer Name" : "Supplier Name"}</Typography>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Invoice No</Typography>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Invoice Date </Typography>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Invoice Amount </Typography>
                                    <Typography className={`${styles.detail_lable}`} sx={{ fontWeight: 'bold' }}>Total Due Amount</Typography>
                                </Grid>
                                <Grid item md={0.6}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={8}>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.CNS_Name}</Typography>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.invoiceNo}</Typography>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.invoiceDate}</Typography>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.invoiceAmount}</Typography>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.totalDueAmount}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                       
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 140 }}>
                    <Table sx={{ minWidth: 700 }} size='small' stickyHeader>
                        <TableHead >
                            <StyledTableRow>
                                <StyledTableCell align="left" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>
                                    Reference No
                                </StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Payment Date</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Paid Amount</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {detailsView && detailsView.payments.map((row, index) => (
                                <>
                                    <StyledTableRow key={row.id} >
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>  {row.paymentReferenceNo}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{dateConversion(row.payment_date)}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{(row.amountTopay).toFixed(2)}</StyledTableCell>
                                    </StyledTableRow>
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    )
}
export default PaymentInvoiceDetails;